export const sendEmailToCustomerQueryHealth = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparing: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;

export const sendInactivityEmailToCustomerQueryHealth = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparingInactivity: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;

export const sendIntakeEmailToCustomerQueryHealth = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { top3Intake: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;

export const sendContinueCoverageEmailToCustomerQueryHealth = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueCoverage: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;
